import { IframeWindow } from '.';
import { document } from '../../api/document';

export class Document implements document.Api {
  constructor(private iframe: IframeWindow) {}
  createDocument(request: document.createDocumentRequest): void {
    this.iframe.postMessage({
      command: 'document.createDocument',
      args: request,
    });
  }

  createBasedOnDocument(request: document.createBasedOnDocumentRequest): void {
    this.iframe.postMessage({
      command: 'document.createBasedOnDocument',
      args: request,
    });
  }

  openUserFolder(): void {
    this.iframe.postMessage({ command: 'precedent.openUserFolder' });
  }

  hasUserPrecedents(): Promise<document.HasUserPrecedentsResponse> {
    return this.iframe.twoWayCall<null, document.HasUserPrecedentsResponse>(
      null,
      (requestId) => {
        this.iframe.postMessage({
          command: 'precedent.hasUserPrecedents',
          args: { requestId },
        });
      },
      (response) => response
    );
  }

  uploadLocalFolder(): Promise<document.UploadLocalFolderResponse> {
    return this.iframe.twoWayCall<null, document.UploadLocalFolderResponse>(
      null,
      (requestId) => {
        this.iframe.postMessage({
          command: 'document.uploadLocalFolder',
          args: { requestId },
        });
      },
      (response) => response
    );
  }

  openFolder(request: document.OpenFolderRequest): void {
    throw new Error('Method not implemented.');
  }

  previewDocument(request: document.PreviewDocumentRequest): void {
    this.iframe.postMessage({
      command: 'document.previewDocument',
      args: request,
    });
  }

  previewPrecedent(request: document.PreviewPrecedentRequest): void {
    this.iframe.postMessage({
      command: 'document.previewPrecedent',
      args: request,
    });
  }

  createDocumentFromContainer(request: document.CreateDocumentFromContainerRequest): void {
    this.iframe.postMessage({
      command: 'document.createDocumentFromContainer',
      args: request,
    });
  }

  createDocumentFromPrecedent(request: document.CreateDocumentFromPrecedentRequest): void {
    this.iframe.postMessage({
      command: 'document.createDocumentFromPrecedent',
      args: request,
    });
  }

  openDocument(request: document.OpenDocumentRequest): void {
    this.iframe.postMessage({
      command: 'document.openDocument',
      args: request,
    });
  }

  reloadDocumentList(request: document.ReloadDocumentListRequest): void {
    this.iframe.postMessage({
      command: 'document.reloadDocumentList',
      args: request,
    });
  }

  editPrecedent(request: document.EditPrecedentRequest): void {
    this.iframe.postMessage({
      command: 'document.editPrecedent',
      args: request,
    });
  }

  selectPrecedent(request: document.SelectPrecedentRequest): Promise<document.SelectPrecedentResponse> {
    return this.iframe.twoWayCall<document.SelectPrecedentRequest, document.SelectPrecedentResponse>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'document.selectPrecedent',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => response
    );
  }

  createDocumentBasedOnURL(request: document.CreateDocumentBasedOnURLRequest): void {
    this.iframe.postMessage({
      command: 'document.createDocumentBasedOnURL',
      args: request,
    });
  }
}
